import {
  BitkitButton,
  type BitkitIconComponent,
  IconDoc,
  IconDownload,
  IconFileDoc,
  IconFilePdf,
  IconFilePlist,
  IconFileZip,
  IconImage,
  IconVideo,
} from '@bitrise/bitkit-v2';
import { Card } from '@chakra-ui/react/card';
import { Text } from '@chakra-ui/react/text';

import { trackTestAttachmentDownloadButtonClicked } from '@/components/test-results/TestResults.tracking';

import { Attachment } from '../../../../TestResults.types';
import { FileType } from '../AttachmentsTab.types';
import { downloadAttachment } from '../AttachmentsTab.utils';

const FILE_TYPE_ICON_MAP: Record<FileType, BitkitIconComponent> = {
  video: IconVideo,
  image: IconImage,
  doc: IconFileDoc,
  pdf: IconFilePdf,
  plist: IconFilePlist,
  text: IconDoc,
  compressed: IconFileZip,
  unknown: IconDoc,
};

const NonMediaAttachment = ({ url, type, fileName }: Attachment & { type: FileType; fileName: string }) => {
  const FileTypeIcon = FILE_TYPE_ICON_MAP[type];

  const handleDownload = () => {
    downloadAttachment(url, fileName);
    trackTestAttachmentDownloadButtonClicked({ attachmentType: type, attachmentFileName: fileName });
  };

  return (
    <Card.Root asChild borderRadius="4" elevation={false} gridColumn="span 3" paddingSize="sm">
      <Card.Body gap="8" display="flex" alignItems="center">
        <FileTypeIcon color="icon/tertiary" />
        <Text textStyle="body/md/regular" flex="1" truncate>
          {fileName}
        </Text>
        <BitkitButton size="sm" icon={IconDownload} variant="tertiary" onClick={handleDownload}>
          Download
        </BitkitButton>
      </Card.Body>
    </Card.Root>
  );
};

export default NonMediaAttachment;
